import React, { useState } from 'react';
import { Copy, Check, RefreshCw } from 'lucide-react';

const ResultDisplay = ({ result, tokensUsed, onRegenerate, loading }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const plainText = result.replace(/<[^>]+>/g, '').trim();
    navigator.clipboard.writeText(plainText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={{ marginTop: '1.5rem' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '0.75rem',
        flexWrap: 'wrap',
        gap: '0.5rem',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 700, color: '#111827' }}>
            Generated Result
          </h3>
          {tokensUsed && (
            <span style={{
              fontSize: '0.75rem',
              background: '#f0fdf4',
              color: '#16a34a',
              border: '1px solid #bbf7d0',
              borderRadius: '20px',
              padding: '0.15rem 0.65rem',
              fontWeight: 600,
            }}>
              {tokensUsed} tokens used
            </span>
          )}
        </div>

        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            onClick={handleCopy}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.4rem',
              background: copied ? '#f0fdf4' : '#f9fafb',
              color: copied ? '#16a34a' : '#374151',
              border: `1px solid ${copied ? '#bbf7d0' : '#e5e7eb'}`,
              borderRadius: '7px',
              padding: '0.45rem 1rem',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            {copied ? <Check size={15} /> : <Copy size={15} />}
            {copied ? 'Copied!' : 'Copy'}
          </button>

          <button
            onClick={onRegenerate}
            disabled={loading}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.4rem',
              background: '#16a34a',
              color: '#fff',
              border: 'none',
              borderRadius: '7px',
              padding: '0.45rem 1rem',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              transition: 'background 0.2s',
            }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = '#15803d'; }}
            onMouseLeave={e => { if (!loading) e.currentTarget.style.background = '#16a34a'; }}
          >
            <RefreshCw size={15} style={{ animation: loading ? 'spin 0.7s linear infinite' : 'none' }} />
            Regenerate
          </button>
        </div>
      </div>

      <div
        style={{
          background: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '10px',
          padding: '1.25rem 1.5rem',
          fontSize: '0.9rem',
          lineHeight: 1.7,
          color: '#111827',
          minHeight: '100px',
        }}
        dangerouslySetInnerHTML={{ __html: result }}
      />
    </div>
  );
};

export default ResultDisplay;
